/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
jQuery(document).ready(function(){
   
  
  	jQuery('#first-name-of-the-deceased').keyup(function(){
  createOrderNote()
      });
  
  jQuery('#last-name-of-the-deceased').change(function(){
  createOrderNote()
      });
  
  jQuery('#age-of-the-deceased').change(function(){
  createOrderNote()
      });
  
  jQuery('#relationship-to-purchaser').change(function(){
  createOrderNote()
      });
  
  jQuery('#instruction').change(function(){
  createOrderNote()
      });
  
  
    jQuery('#rdo-cntr input[type=radio]').change(function(){
    
 
    if( jQuery(this).val() == 'SOMEONE ELSE'){
     	jQuery("#addl-instn").show();
      createOrderNote()
    }else{
      	jQuery("#first-name-of-the-deceased").val('');
      	jQuery("#last-name-of-the-deceased").val('');
      	jQuery("#age-of-the-deceased").val('');
      	jQuery("#relationship-to-purchaser").val('');
      	jQuery("#addl-instn").hide();
      createOrderNote()
    }
  
      
  
  });
  

	jQuery("#first-name-of-the-deceased").val('');
  	jQuery("#last-name-of-the-deceased").val('');
  	jQuery("#age-of-the-deceased").val('');
  	jQuery("#relationship-to-purchaser").val('');
  	jQuery("#addl-instn").hide();
  
  
  //Fixed header logo change
  jQuery('header.header .header__logo .header__logo-link').append('<img src="https://cdn.shopify.com/s/files/1/0293/0533/9948/files/logo.png?v=1591348741" class="header__logo-img logo-black" alt="Beyond Burials" itemprop="logo" />');

  //ID wise scroll
  jQuery('.arrow').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        jQuery('html,body').animate({
          scrollTop: target.offset().top - 100
        }, 700);
        return false;
      }
    }
  });

  jQuery('.scroll_animation_menu .page-navigator').scroller({});
  
  
  

  
  
  
  
  
  
  
});



function createOrderNote(){
  var orderNote = 'Is this product for you or someone else: '+ jQuery('#rdo-cntr input[type=radio]:checked').val() + '\n';
  
  if (jQuery('#rdo-cntr input[type=radio]:checked').val() == 'SOMEONE ELSE') {
      var fname_text = jQuery("#first-name-of-the-deceased").val();
      var lname_text = jQuery("#last-name-of-the-deceased").val();
      var age_text = jQuery("#age-of-the-deceased").val();
      var relationship_text = jQuery("#relationship-to-purchaser").val();
      var instruction_text = jQuery("#instruction").val();

      orderNote = orderNote + 'First Name of the deceased: '+ fname_text + '\nLast Name of the deceased:' + lname_text + '\nAge of the deceased:' + age_text + '\nRelationship to purchaser: '+ relationship_text + '\n';
  }
  
  orderNote = orderNote + 'Instruction: ' + instruction_text;
  
  jQuery("#CartSpecialInstructions").val(orderNote)
  
  
  
}

                          